import { RouteConfig } from 'vue-router'
import { restrictedLocationRouteNames } from '@/routes/constants/location'

const RestrictedLocation = () =>
  import(
    /* webpackChunkName: "agency-billing-inactive-location" */ '@/pmd/pages/agency/billing/RestrictLocation.vue'
  ).then(m => m.default)

export const restrictedRoute: RouteConfig[] = [
  {
    path: 'restricted',
    name: restrictedLocationRouteNames.default,
    component: RestrictedLocation,
    meta: {
      hideTopBar: true,
    },
  }
]
